<template lang="pug">

  .wrapper-extra-time-dash-body

    // IMPORTANT: dont remove the inline styles, it's necessary to work in new window mode
    .legends(v-if="compGraphFormated", ref="legends" style="display: grid; grid-auto-columns: 1fr;")
      div(:style="`grid-column-start: 1; grid-column-end: ${typeView === 'special' ? '9' : '8'}; text-align: center; padding-top: 20px;`")
        span.fs-19.main {{ periodInfoLegend.type }}
        span.fs-13 {{ periodInfoLegend.interval }}

      label(v-for="leg in compGraphFormated.datasets.map(i => ({label: i.label, field: i.field}))",
      style="grid-row: 1; display: grid; justify-items: start; grid-template-columns: .5fr 1fr; ")

        div(style="width: 20px; height: 15px; align-self: center; justify-self: center", :style="{'background-color': colors[leg.field]}")
        div.fs-11(style="align-self: center") {{ leg.label }}

    br
    // END IMPORTANT

    .change-chart-type(v-if="compGraphFormated || companiesGraph.loading")
      span.icon-ptt-icons-grafico.background-primary(style="padding: 2px;")
      span.icon-ptt-icons-pizza.to-click(style="padding: 2px", @click="$emit('changeChartType', {id: 'pie'})")

    .full-screen(v-if="compGraphFormated || companiesGraph.loading")
      span.icon-ptt-icons-expandir.to-click.fs-21.full-screen-togler(
        @click="$emit('toggleFullScreen')"
      )

    ChartContainer.companies-graph(
      :graphData="compGraphFormated",
      :loading="companiesGraph.loading",
      :graphTitle="compGraphFormated ? compGraphFormated.title : ''",
      :barsWidth="labelCompany == 'name' ? 10 : 5",
      :showLegends="true",
      :colors="colors"
      @click="loadEmployeesGraph",
      @loadChart="loadCompaniesGraph"
      @toggleIgnoreEmpty="toggleIgnoreEmpty"
    )

    ChartContainer.employees-graph(
      :graphData="employeesGraphFormated",
      :loading="employeesGraph.loading",
      :graphTitle="employeesGraphFormated ? employeesGraphFormated.title : ''",
      :graphSubTitle="employeesGraphFormated ? employeesGraphFormated.subtitle : ''",
      :barsWidth="labelEmployee == 'name' ? 10 : 5",
      @click="loadPeriodGraph",
      @loadChart="loadEmployeesGraph({labelClicked: null})"
      @toggleIgnoreEmpty="toggleIgnoreEmpty"
    )
      template(v-if="employeesGraphFormated")
        div.title
          span.fs-19.main {{ employeesGraphFormated.title }}
          span.to-click.fs-13(:title="'Ir para folha do ' + $ws('company')",
            @click="() => openCompanyTimesheet(displaying.company)")
            | ({{ employeesGraphFormated.subtitle }})

    ChartContainer.period-graph(
      v-if="typeView !== 'special'",
      :graphData="periodGraphFormated",
      :loading="periodGraph.loading",
      :graphTitle="periodGraphFormated ? periodGraphFormated.title : ''",
      :graphSubTitle="periodGraphFormated ? periodGraphFormated.subtitle : ''",
      @loadChart="loadPeriodGraph({labelClicked: null})"
      @toggleIgnoreEmpty="toggleIgnoreEmpty"
    )
      template(v-if="periodGraphFormated")
        div.title
          span.fs-19.main {{ periodGraphFormated.title }}
          span.to-click.fs-13(:title="'ir para folha do ' + $ws('employee')",
            @click="() => openEmployeeTimesheet(displaying.employee)")
            | ({{ periodGraphFormated.subtitle }}

    .calendar(v-if="typeView === 'special' && calendar && !calendar.loading && calendar.data")
      div.title
        span.fs-19.main período
        span.to-click.fs-13(@click="() => openEmployeeTimesheet(displaying.employee)") ({{ displaying.employee.name }})

      Calendar.calendar(
        v-for="(empPeriod, index) in calendar.data",
        :key="index",
        dayFormat="DD.MM",
        :startDate="startDate", :endDate="endDate"
      )

        .custom-day(slot-scope="{ date, dateIndex }",
        :style="calcDayColor(empPeriod.dates[dateIndex])")

          label {{ date.pretty }}

          template(v-if="empPeriod.dates[dateIndex]")
            label(v-if="empPeriod.dates[dateIndex].absence") Falta
            label(v-if="empPeriod.dates[dateIndex].justify") Dispensa
            label(v-if="empPeriod.dates[dateIndex].folgaTrabalhada") Folga Trabalhada
            label(v-if="empPeriod.dates[dateIndex].suspension") Suspensão
            label(v-if="empPeriod.dates[dateIndex].holidayWorked") Feriado Trabalhado

</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import Calendar from 'src/common/date/Calendar.vue'
import ChartContainer from './ChartContainer'
import { formatLabelTofit } from 'src/components/DashBoards/utils'

export default {
  props: {
    periodInfoLegend: {},
    labelCompany: {required: true},
    labelEmployee: {required: true},
    colors: {required: true}
  },
  data () {
    return {
      displaying: { //  the current item selected to show in header
        company: {},
        employee: {}
      },
      textsPerView: {
        extraTime: {
          title: 'Apontamentos'
        },
        special: {
          title: 'Eventos'
        },
        whb: {
          title: 'Banco de Horas'
        }
      },
      fieldsInfos: {
        'extraTime50Tot': {name: 'Hora Extra', stacked: false},
        'extraTime100Tot': {name: 'Hora Extra Extraordinárias', stacked: false},
        'extraTimeSpecialTot': {name: 'Hora Extra Especiais', stacked: false},
        'extraTime50NotTot': {name: 'Hora Extra Noturnas', stacked: false},
        'extraTime100NotTot': {name: 'H.E. Extraord Not', stacked: false},
        'extraTimeSpecialNotTot': {name: 'Hora Extra Especiais Noturnas', stacked: false},
        'oddPts': {name: 'Batida ímpar', stacked: false},
        'vacation': {name: 'Férias', stacked: false},
        'leave': {name: 'Afastamento', stacked: false},
        'delayTime': {name: 'Atraso', stacked: false},
        'absence': {name: 'Faltas', stacked: false},
        'justify': {name: 'Justificativas', stacked: false},
        'folgaTrabalhada': {name: 'Folga Trabalhada', stacked: false},
        'holidayWorked': {name: 'Feriado Trabalhado', stacked: false},
        'suspension': {name: 'Suspensão', stacked: false},
        'allTimes': {name: 'Consolidado', stacked: true},
        'generalExtraTime': {name: 'Acumulado', stacked: true},
        'generalDelay': {name: 'Compensado', stacked: true}
      },
      ignoreEmpty: true,
      lastClickedEmployee: undefined,
      lastClickedPeriod: undefined
    }
  },
  computed: {
    ...mapState('dashboards',
      ['companies', 'types', 'startDate', 'endDate', 'chartType', 'typeView']
    ),
    ...mapState('dashboards/bars',
      ['companiesGraph', 'employeesGraph', 'periodGraph', 'calendar']
    ),
    compGraphFormated () {
      if (!this.companiesGraph.data) { return null }

      const noEmpty = this.treatEmpty(this.companiesGraph.data)

      const formater = (i) => {
        return formatLabelTofit(i[this.labelCompany === 'name' ? 'name' : 'code'])
      }

      return {
        ...this.formatGraph(noEmpty, formater),
        // title: this.textsPerView[this.typeView].title.toUpperCase() + ' POR LOCAL  DE TRABALHO',
        subtitle: this.displaying.employee.name
      }
    },
    employeesGraphFormated () {
      if (!this.compGraphFormated || !this.employeesGraph.data) { return null }

      const noEmpty = this.treatEmpty(this.employeesGraph.data)

      const formater = (i) => {
        return formatLabelTofit(i[this.labelEmployee === 'name' ? 'name' : 'code'])
      }

      return {
        ...this.formatGraph(noEmpty, formater),
        title: this.textsPerView[this.typeView].title.toLowerCase(),
        subtitle: this.displaying.company.name
      }
    },
    periodGraphFormated () {
      if (!this.employeesGraphFormated || (!this.periodGraph.data || !!this.periodGraph.data.length)) {
        return null
      }

      return {
        ...this.formatGraph(this.periodGraph.data, i => moment(i).format('DD/MM')),
        title: this.textsPerView[this.typeView].title.toLowerCase(),
        subtitle: this.displaying.employee.name
      }
    }
  },
  methods: {
    formatGraph (graphData, labelsFormater) {
      const datasets = []
      graphData.datasets.forEach(item => {
        datasets.push({
          ...item,
          backgroundColor: this.colors[item.field],
          stack: this.fieldsInfos[item.field].stacked && this.chartType === 'bars' ? 'merge' : item.field,
          type: 'bar'
        })
      })

      const labels = graphData.labelsData.map(labelsFormater)

      return {
        ...graphData,
        datasets,
        labels
      }
    },

    treatEmpty (graphData) {
      if (!this.ignoreEmpty) { return graphData }

      const datasets = graphData.datasets.map(item => ({...item, data: []}))
      const labelsData = []

      for (let i = 0; i < graphData.labelsData.length; i++) {
        const anyValue = graphData.datasets.find(item => item.data[i] !== 0)

        if (anyValue) {
          datasets.forEach((type, index) => {
            type.data.push(graphData.datasets[index].data[i])
          })
          labelsData.push(graphData.labelsData[i])
        }
      }

      return {datasets, labelsData}
    },

    calcDayColor (dayInfo) {
      for (const property in dayInfo) {
        if (dayInfo.hasOwnProperty(property) && dayInfo[property] === true) {
          return {
            'background-color': this.colors[property]
          }
        }
      }
    },

    async loadCompaniesGraph () {
      if (!this.$store.state.dashboards.companies.selected.length) { return }

      this.$store.commit('dashboards/bars/employeesGraph', {data: null, loading: false})
      this.$store.commit('dashboards/bars/periodGraph', {data: null, loading: false})
      this.$store.commit('dashboards/bars/calendar', {data: null, loading: false})

      this.$store.dispatch('dashboards/bars/loadGraphs', {
        view: 'companies',
        companies: this.companies.selected.map(i => i.id),
        graph: 'companiesGraph',
        ignoreEmpty: this.ignoreEmpty
      })
    },
    async loadEmployeesGraph ({ labelClicked }) {
      this.$store.commit('dashboards/bars/periodGraph', {data: null, loading: false})
      this.$store.commit('dashboards/bars/calendar', {data: null, loading: false})

      let company
      if (labelClicked) {
        company = labelClicked
        this.lastClickedEmployee = labelClicked
      } else {
        company = this.lastClickedEmployee
      }

      if (!company) return
      this.displaying.company = company

      this.$store.dispatch('dashboards/bars/loadGraphs', {
        view: 'employees',
        companies: [company.id],
        graph: 'employeesGraph',
        ignoreEmpty: this.ignoreEmpty
      })
    },
    async loadPeriodGraph ({ labelClicked }) {
      let employee
      if (labelClicked) {
        employee = labelClicked
        this.lastClickedEmployee = labelClicked
      } else {
        employee = this.lastClickedEmployee
      }

      if (!employee) return
      this.displaying.employee = employee

      this.$store.dispatch('dashboards/bars/loadGraphs', {
        view: 'period',
        employees: [employee.id],
        graph: this.typeView === 'extraTime' ? 'periodGraph' : 'calendar',
        ignoreEmpty: this.ignoreEmpty
      })
    },
    openEmployeeTimesheet (employee) {
      console.log(employee, this.displaying)
      this.$router.goToTimesheet(moment(), employee, null, true)
    },
    openCompanyTimesheet (company) {
      this.$router.goToTimesheet(moment(), null, company, true)
    },
    toggleIgnoreEmpty (value) {
      this.ignoreEmpty = value
    }
  },
  components: {ChartContainer, Calendar}
}
</script>

<style scoped>
.wrapper-extra-time-dash-body {
  position: relative;
  display: grid;
  padding-top: 40px;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  grid-template-rows: 0.2fr .2fr minmax(0fr, 1.5fr) minmax(0fr, 1.5fr) minmax(0fr, 1.5fr) auto;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    "legends legends"
    "change-chart fullscreen"
    "companies-graph companies-graph"
    "employees-graph employees-graph"
    "period-graph period-graph"
    "calendar calendar";
}

.wrapper-extra-time-dash-body > .legends {
  grid-area: legends;
}

.wrapper-extra-time-dash-body > .companies-graph {
  grid-area: companies-graph;
}
.companies-graph, .employees-graph, .period-graph {
  width: 100%; /* fixes scroll in firefox */
  max-width: 100%; /* fixes scroll in firefox */
}

.wrapper-extra-time-dash-body > .employees-graph {
  grid-area: employees-graph;
  /* height: auto; */
}

.wrapper-extra-time-dash-body > .period-graph {
  grid-area: period-graph;
}

.wrapper-extra-time-dash-body > .dates {
  grid-area: dates;
}
.wrapper-extra-time-dash-body > .calendar {
  grid-area: calendar;
  margin-bottom: 50px;
}

.custom-day {
  width: 100%;
  height: 100%;
  justify-items: center;
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: 1fr 1fr;
  border-radius: 5px;
}

.change-chart-type {
  grid-area: change-chart;
  width: fit-content;
  background-color: lightgray;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
}
.full-screen {
  grid-area: fullscreen;
  justify-self: end;
}

.title {
  display: flex;
  align-items: center;
  justify-content: center;
}

.main {
  padding-right: 5px;
}

</style>
